(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snoozle-mobile-sticky"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('snoozle-mobile-sticky')) {
    customElements.define(
      'snoozle-mobile-sticky',
      class extends HTMLElement {
        connectedCallback() {
          this.setupFrame = requestAnimationFrame(() => {
            this.bar = this.querySelector('.snz-sticky__bar');
            this.button = this.querySelector('.snz-sticky__button');

            if (!this.bar || !this.button) return;

            this.onScroll = () => {
              if (this.scrollFrame) return;

              this.scrollFrame = requestAnimationFrame(() => {
                this.scrollFrame = null;
                this.bar.hidden =
                  window.scrollY < Number(this.dataset.showAfter || 0);
              });
            };

            this.onClick = (event) => {
              if (
                event.metaKey ||
                event.ctrlKey ||
                event.shiftKey ||
                event.altKey
              ) return;

              const target =
                document.getElementById('MainContent') ||
                document.querySelector('main');

              if (!target) return;

              event.preventDefault();

              target.scrollIntoView({
                behavior: window.matchMedia(
                  '(prefers-reduced-motion: reduce)'
                ).matches ? 'instant' : 'smooth',
                block: 'start'
              });
            };

            window.addEventListener('scroll', this.onScroll, {
              passive: true
            });

            this.button.addEventListener('click', this.onClick);
            this.onScroll();
          });
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.setupFrame);
          cancelAnimationFrame(this.scrollFrame);
          window.removeEventListener('scroll', this.onScroll);
          this.button?.removeEventListener('click', this.onClick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
